import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Controller, useForm } from "react-hook-form";
import { useFetchEntityConfig } from "features/metadesk/redux/hooks";
import {
  Button,
  COLOR,
  VARIANT,
} from "@metacrm/metacrm-material-ui/dist/Button";
import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import {
  StyledBasicModalContainer,
  StyledCloseBtn,
  StyledModalTitle,
  StyledModalContent,
  StyledButtonArea,
} from "./Modal.styles";
import _ from "lodash";
import { useIntl } from "react-intl";
import { useTheme } from "@mui/styles";
import { enqueueSnackbar } from "features/common/redux/actions";
import { useDispatch } from "react-redux";

export default function CreateKolGroupModal({
  open,
  handleClose,
  entityName,
  choose,
}) {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const { entityConfig } = useFetchEntityConfig();
  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: "onSubmit",
    defaultValues: { groupName: "", groupMember: choose },
  });

  useEffect(() => {
    reset({
      groupName: "",
      groupMember: choose,
    });
  }, [choose]);

  const onSubmit = async (data) => {
    try {
      console.log("Creating group with data:", data);
      dispatch(
        enqueueSnackbar({
          message: formatMessage({ id: "kolGroup.create.success" }),
          options: { variant: "success" },
        })
      );
      closeModal();
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: formatMessage({ id: "kolGroup.create.error" }),
          options: { variant: "error" },
        })
      );
    }
  };

  const closeModal = () => {
    handleClose();
    setTimeout(() => reset(), 300); // wait for modal to unmount
  };

  return (
    <Modal
      open={open}
      className={"modal"}
      onClose={closeModal}
      sx={{ zIndex: 10000 }}
    >
      <StyledBasicModalContainer>
        <StyledModalTitle>
          <Box>{formatMessage({ id: "kolGroup.createGroup.title" })}</Box>
          <StyledCloseBtn
            size={24}
            color={theme.customColors.grey[700]}
            onClick={closeModal}
          >
            <i className="meta-crm-icon-ic_cancel" />
          </StyledCloseBtn>
        </StyledModalTitle>
        <StyledModalContent>
          <Controller
            name="groupName"
            control={control}
            rules={{
              required: {
                value: true,
                message: formatMessage({ id: "global.error.requiredField" }),
              },
              maxLength: {
                value: 25,
                message: formatMessage(
                  { id: "global.error.maxLength" },
                  { length: 25 }
                ),
              },
            }}
            render={({ field }) => (
              <InputField
                {...field}
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                placeholder={formatMessage({ id: "kolGroup.name.placeholder" })}
                title={formatMessage({ id: "kolGroup.name.label" })}
                maxLength={25}
                isRequired
                errors={errors.groupName?.message}
              />
            )}
          />
        </StyledModalContent>
        <StyledButtonArea>
          <Button
            color={COLOR.SECONDARY}
            variant={VARIANT.TEXT}
            onClick={closeModal}
            style={{ width: 120 }}
          >
            {formatMessage({ id: "global.btn.cancel" })}
          </Button>
          <Button
            color={COLOR.SECONDARY}
            disabled={!isValid}
            onClick={handleSubmit(onSubmit)}
            style={{ width: 120 }}
          >
            {formatMessage({ id: "global.btn.create" })}
          </Button>
        </StyledButtonArea>
      </StyledBasicModalContainer>
    </Modal>
  );
}
